import { render, staticRenderFns } from "./CreateDrawing.vue?vue&type=template&id=ecef407c&"
import script from "./CreateDrawing.vue?vue&type=script&lang=js&"
export * from "./CreateDrawing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports